import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  AccessControl,
  PermissionRequired,
  //@ts-ignore
} from "@careinfo/permission-required";
import CreateManifest from "../pages/Dispatch Manifest/CreateManifest";
import EditManifest from "../pages/Dispatch Manifest/EditManifest";
import ManifestList from "../pages/Dispatch Manifest/ManifestList";
export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route
            path="/"
            element={
              <AccessControl
                children={<ManifestList />}
                allowedPermissions={["can_view_manifest"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/manifest"
            element={
              <AccessControl
                children={<ManifestList />}
                allowedPermissions={["can_view_manifest"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/create"
            element={
              <AccessControl
                children={<CreateManifest />}
                allowedPermissions={["can_create_manifest"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/edit/:id"
            element={
              <AccessControl
                children={<EditManifest />}
                allowedPermissions={["can_editupdate_manifest"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={1000} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
